module.exports = __webpack_public_path__ + "img/Copy.f25cb3aab.svg";